var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 50,
    viewBox: "0 0 39 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2938 0C8.65518 0 0 8.65518 0 19.2937C0 22.9674 1.00107 26.8676 2.97529 30.8858C4.54072 34.0721 6.71963 37.342 9.45156 40.6047C14.0894 46.1438 18.6535 49.6979 18.8455 49.8467C18.9738 49.946 19.1316 49.9999 19.2938 49.9998C19.452 49.9998 19.6103 49.9487 19.7422 49.8467C19.9343 49.698 24.4983 46.1438 29.1361 40.6047C31.868 37.3419 34.047 34.072 35.6124 30.8858C37.5866 26.8676 38.5877 22.9674 38.5877 19.2937C38.5877 8.65518 29.9325 0 19.2938 0ZM19.2938 12.6233C22.9719 12.6233 25.9643 15.6156 25.9643 19.2937C25.9643 22.9718 22.972 25.9642 19.2938 25.9642C15.6157 25.9642 12.6234 22.9719 12.6234 19.2937C12.6234 15.6156 15.6157 12.6233 19.2938 12.6233Z",
    fill: "#744DFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2942 0C18.5703 0 17.8559 0.0414062 17.1523 0.119531C26.7866 1.18857 34.3043 9.3791 34.3043 19.2938C34.3043 22.9675 33.3033 26.8677 31.329 30.8859C29.7636 34.0722 27.5847 37.3421 24.8527 40.6048C21.8771 44.1587 18.932 46.8953 17.1523 48.4398C18.1465 49.3026 18.7771 49.7935 18.8459 49.8467C18.9742 49.946 19.1319 49.9999 19.2942 49.9998C19.4523 49.9998 19.6106 49.9487 19.7426 49.8467C19.9347 49.698 24.4987 46.1438 29.1365 40.6047C31.8684 37.3419 34.0474 34.072 35.6128 30.8858C37.587 26.8676 38.5881 22.9674 38.5881 19.2937C38.5881 8.65518 29.9329 0 19.2942 0Z",
    fill: "#8664FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.fdb1da9577dc4a9b19c73bf9e06ed973.svg";
export { ForwardRef as ReactComponent };